import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { teamPageConfig } from "./teamPageConfig";

export const teamRecordDefinition: RecordDefinition = {
  path: "/team",
  entityName: "dwteam",
  listRoute: "/teams",
  backTitle: "Back to teams",
  allowedRoles: administratorRoles,
  config: teamPageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Team",
    newRecordTitle: "New Team",
  },
};
